/**
 * 
 * key
 * 
 */


const key = 'ZnJlZWxhbmNlclF1YW50aXR5TGlzdA=='

export default key 